export const initialListingFilterObj = {
  destination: {
    display: 'All',
    slug: 'All',
    id: 0,
  },
  travelType: {
    display: 'All',
    slug: 'All',
    subtypeSlug: '',
    id: 0,
  },
};

export const initialFinderFilterObj = {
  destination: [],
  travelType: {
    display: 'All',
    slug: 'All',
    subtypeSlug: '',
    id: 0,
  },
  collection: [],
  holidayStyle: [],
};

export const listingPerPageLimit = 16;

export const reviewsPerPageLimit = 9;
